import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import EditForm from "../EditForm";

const SettingsTab = ({ agreement, setAgreement, setHasChanges }) => {
  return (
    <>
      <div className="flex justify-between items-center">
        <h2>Settings</h2>
        <Link to={`/${agreement.agreementPublicId}/tenant/create`} className="btn-primary hidden">
          <FontAwesomeIcon icon={faPlus} className="mr-2 text-lg" />
          CHANGE THIS TOO
        </Link>
      </div>
      <EditForm
        data={agreement}
        setData={setAgreement}
        setHasChanges={setHasChanges}
        disabled={false}
        fields={[
          { key: "createUserFormUrl", label: "Create user URL", type: "text" },
          { key: "updateUserFormUrl", label: "Edit user URL", type: "text" },
          { key: "deleteUserFormUrl", label: "Delete user URL", type: "text" },
          { key: "supportManualUrl", label: "Support manual URL", type: "text" },
          { key: "scoFormsEnabled", label: "New user forms (SCO)", type: "switch" },
        ]}
      />
    </>
  );
};

export default SettingsTab;
